module.exports = __webpack_public_path__ + "static/bg.49adf4e8.png";